import React, { useEffect, useState } from "react";
import { Check, Package } from "lucide-react";
import { Button } from "../components/ui/button";
import { SectionHeading } from "../components/Section";
import { getIcon } from "../lib/icons";
import { getBundles, formatEUR } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { useLang } from "../i18n/LanguageContext";
import { toast } from "sonner";

export default function Bundles() {
  const { t, lang } = useLang();
  const { addToCart } = useStore();
  const [bundles, setBundles] = useState([]);
  useEffect(() => { getBundles().then((d) => setBundles(d.bundles)).catch(() => {}); }, []);

  const addBundle = (b) => {
    b.items.forEach((it) => addToCart({ slug: it.slug, name: it.name, price_eur: it.kind === "product" ? it.price_eur * 0.9 : it.price_eur * 0.9, image: it.image, kind: it.kind }));
    toast.success(`${lang === "hr" ? b.name_hr : b.name_en} \u2014 ${t("common.added")}`);
  };

  return (
    <div className="pt-24 pb-16 container-lumeo">
      <SectionHeading eyebrow={t("nav.bundles")} title={t("bundles.title")} subtitle={t("bundles.subtitle")} />
      <div className="grid md:grid-cols-2 gap-6">
        {bundles.map((b) => {
          const Icon = getIcon(b.icon);
          return (
            <div key={b.slug} data-testid={`bundle-${b.slug}`} className="rounded-2xl card-ceramic p-6 flex flex-col">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-cyanx/10"><Icon className="h-6 w-6 text-cyanx" /></span>
                  <div><h3 className="font-display text-xl">{lang === "hr" ? b.name_hr : b.name_en}</h3><p className="text-xs text-muted-foreground">{lang === "hr" ? b.tagline_hr : b.tagline_en}</p></div>
                </div>
                <span className="chip text-mintx whitespace-nowrap">{t("bundles.youSave")} {formatEUR(b.savings_eur)}</span>
              </div>
              <div className="mt-5 space-y-2 flex-1">
                <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{t("bundles.includes")}</p>
                {b.items.map((it) => (
                  <div key={it.slug} className="flex items-center gap-3 rounded-lg hairline p-2">
                    <span className="h-10 w-10 rounded-md bg-black/40 overflow-hidden inline-flex items-center justify-center shrink-0">
                      {it.image ? <img src={it.image} alt="" className="h-full w-full object-contain p-0.5" /> : <Package className="h-4 w-4 text-cyanx" />}
                    </span>
                    <span className="text-sm flex-1">{it.name}</span>
                    <span className="font-mono text-xs text-muted-foreground">{formatEUR(it.price_eur)}</span>
                  </div>
                ))}
              </div>
              <div className="mt-5 flex items-center justify-between">
                <div><span className="font-display text-2xl">{formatEUR(b.bundle_price_eur)}</span> <span className="text-sm text-muted-foreground line-through ml-1">{formatEUR(b.total_eur)}</span></div>
                <Button onClick={() => addBundle(b)} className="btn-glow border-0">{t("bundles.addBundle")}</Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
